module.exports = __webpack_public_path__ + "3336a6125f17f747cfce918a810f7ef9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/34.jpg
// module id = 1362
// module chunks = 47